import { render, staticRenderFns } from "./ModalOnboarding.vue?vue&type=template&id=a0510400"
import script from "./ModalOnboarding.vue?vue&type=script&lang=js"
export * from "./ModalOnboarding.vue?vue&type=script&lang=js"
import style0 from "./ModalOnboarding.vue?vue&type=style&index=0&id=a0510400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports